import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

import { performSimplAuthSignOut } from "../features/Auth/signOut";

/**
 * Shared sign-out wrapper for legacy callers (top-nav menu, idle
 * timer, etc.). Kept around so existing imports keep working without
 * each call site having to know about `performSimplAuthSignOut`'s
 * argument shape.
 */
export const handleSignOut = ({
  dispatch
}: {
  dispatch: Dispatch<AnyAction>;
}) => {
  void performSimplAuthSignOut({ dispatch });
};

export const SignOutButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Button
      variant="contained"
      onClick={() => handleSignOut({ dispatch })}
    >
      {t("Sign Out")}
    </Button>
  );
};
